import React from 'react';
import { inject, observer } from 'mobx-react';
import H5WaterfallFlow from './h5';
import PCWaterfallFlow from './pc';
import type { AppStore } from '@stores/app/store';
import type { SiteStore } from '@stores/site/store';
import type { UserAction } from '@stores/user/action';
import { withRouter, RouteComponentProps } from 'react-router-dom';

interface WaterfallFlowProps extends RouteComponentProps {
    app?: AppStore;
    site?: SiteStore;
    user?: UserAction;
    data?: any;
    type?:   any;   // 类型 1：正常作品列表 2：我的作品
    loading?: boolean;
    hasMore?: boolean;
    onLoadMore?: () => void;
    emptyText?: string; // 为空时提示文字
    emptyIcon?: string; // 为空时icon
    emptyBoxStyle?: any; // 为空状态时的自定义样式
    searchKeyword?: any
    voteClick?: Function;   // 投票
    canvassForVotesClick?: Function;    // 拉票
    photographyDetail?: any // 摄影大赛详情
    manageCurrentWork?: Function;   // 作品详情右上角点击管理事件
    closeDetailTrigger?: number; // 触发关闭详情的标记（值变化时触发关闭）
    currentItemClick?: Function;   // 点击打开详情
}

@inject('app', 'site', 'user')
@observer
class WaterfallFlow extends React.Component<WaterfallFlowProps> {
    componentDidMount() {
        // 可以在这里添加初始化逻辑
        // console.log('组件组件');
    }

    render() {
        const { site, app, data, searchKeyword,loading, hasMore, onLoadMore, voteClick, canvassForVotesClick, photographyDetail, closeDetailTrigger, currentItemClick, manageCurrentWork, ...props } = this.props;
        const platform = app?.platform || 'h5';
         // 确保传递 data 属性，即使为空数组
        const postListData = data || [];
        // console.log(postListData, platform, '组件入口')
        if (platform === 'pc') {
            return <PCWaterfallFlow {...props} searchKeyword={searchKeyword} data={postListData} loading={loading}
            hasMore={hasMore}
            onLoadMore={onLoadMore || (() => { })}/>;
        } else {
            return <H5WaterfallFlow {...props} data={postListData} photographyDetail={photographyDetail} currentItemClick={currentItemClick} closeDetailTrigger={closeDetailTrigger} voteClick={voteClick} canvassForVotesClick={canvassForVotesClick} manageCurrentWork={manageCurrentWork} searchKeyword={searchKeyword} loading={loading}
            hasMore={hasMore}
            onLoadMore={onLoadMore || (() => { })} />;
        }
    }
}

export default withRouter(WaterfallFlow);